const ENCODED_RATE_ROOM_FORMAT = /^p(\d+)r(\d+)$/i;
// Canonical details id: "{code}" or "{rate_code}.{room_code}", digits only.
const CANONICAL_RATE_ROUTE_ID = /^\d+(\.\d+)?$/;

export function isEncodedRateRouteId(id) {
  if (!id || typeof id !== 'string') {
    return false;
  }

  return ENCODED_RATE_ROOM_FORMAT.test(id);
}

/**
 * Normalizes a rate route id to the canonical format (e.g. "p23r5" -> "23.5").
 * Returns the id unchanged when it is already in canonical form.
 * @param {string} id
 * @returns {string}
 */
export function normalizeRateRouteId(id) {
  if (!id || typeof id !== 'string') {
    return id ?? '';
  }

  const rateRoomMatch = id.match(ENCODED_RATE_ROOM_FORMAT);
  if (rateRoomMatch) {
    return `${rateRoomMatch[1]}.${rateRoomMatch[2]}`;
  }

  return id;
}

/**
 * True when a room/rate details id is "23", "23.5" or the encoded "p23r5".
 * Anything else (e.g. a crawler opening "/room/details/roomRateId") is not
 * an id and must never reach the CRS calendar.
 * @param {string} id
 * @returns {boolean}
 */
export function isValidRateRouteId(id) {
  if (!id || typeof id !== 'string') {
    return false;
  }

  return CANONICAL_RATE_ROUTE_ID.test(normalizeRateRouteId(id));
}

/**
 * Returns the part when it is a numeric code, otherwise 0.
 * @param {string|undefined} part
 * @returns {string|number}
 */
export function numericRouteIdPart(part) {
  const trimmed = typeof part === 'string' ? part.trim() : '';
  return /^\d+$/.test(trimmed) ? trimmed : 0;
}
